import * as navigate from 'app/area/shared/navigation';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { actionCreators as responseCachingActionCreators } from 'app/area/shared/response-caching/actions';

import { CreateNewDraft, CreateNewDraftFailure } from './action-types';

const isValidParent = (parentConnection) => parentConnection && parentConnection.draftId && parentConnection.connectionTypeId;

type ParentConnection = { draftId: number; connectionTypeId: number };

export const actionCreators = (api: any) => ({

  createCase: (caseTypeId: number, caseContextId?: number, parentConnection?: ParentConnection, entityPath?: any[]):
    ActionDispatching<any, ApplicationState> =>
    async (dispatch: any, getState: any) => {

      let copyFrom = undefined;

      if(isValidParent(parentConnection)) {
        copyFrom = { 
          source: { 
            draftId: parentConnection.draftId,
            entityPaths: [ entityPath ]
          },
          context: { connectionTypeId: parentConnection.connectionTypeId }
        };
      }

      const utcOffset = getState().app.settings.utcOffset;
      
      try {
        dispatch(new CreateNewDraft(caseTypeId));
        const body: any = { caseTypeId, copyFrom, caseContextId };
        if (caseContextId) {
          body.caseContextId = caseContextId;
        }
        
        const { location: draftId, response } = await api.createCase(body, { utcOffset });
        
        // Precache ui-definition
        if (response && response.data && response.data.caseContext && response.data.caseType) {
          const returnedCaseTypeId = response.data.caseType.v;
          const returnedCaseContextId = response.data.caseContext.v;
          dispatch(responseCachingActionCreators.getUiDefinition(returnedCaseTypeId, returnedCaseContextId));
        }
        
        navigate.toDraft(draftId);
      } catch (err) {
        dispatch(new CreateNewDraftFailure(caseTypeId, err));
        navigate.toStartupView();
      }
    }

});
